import dynamic from "next/dynamic";

const Heading = dynamic(() => import("./Heading"));

export default Heading;
